import axios from "axios";
const apiURL = process.env.REACT_APP_API_URL;

export const getAllProduct = async () => {
  try {
    let res = await axios.get(`${apiURL}/api/product/all-product`);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const createPorductImage = async ({ pImage }) => {
  /* Most important part for uploading multiple image  */
  let formData = new FormData();
  for (const file of pImage) {
    formData.append("pImage", file);
  }
  /* Most important part for uploading multiple image  */
};

export const createProduct = async ({
  pName,
  pDescription,
  pImage,
  pStatus,
  pCategory,
  pQuantity,
  pPrice,
  pOffer,
}) => {
  /* Most important part for uploading multiple image  */
  let formData = new FormData();
  for (const file of pImage) {
    formData.append("pImage", file);
  }
  /* Most important part for uploading multiple image  */
  formData.append("pName", pName);
  formData.append("pDescription", pDescription);
  formData.append("pStatus", pStatus);
  
  // Append each category ID separately for proper array handling
  if (Array.isArray(pCategory)) {
    pCategory.forEach(catId => {
      formData.append("pCategory[]", catId);
    });
  }
  
  formData.append("pQuantity", pQuantity);
  formData.append("pPrice", pPrice);
  formData.append("pOffer", pOffer);

  try {
    let res = await axios.post(`${apiURL}/api/product/add-product`, formData);
    console.log("Create product response:", res.data);
    return res.data;
  } catch (error) {
    console.error("Create product API error:", error);
    return { error: "Erreur lors de la création du produit" };
  }
};

export const editProduct = async (product) => {
  console.log("Editing product:", product);
  /* Most important part for updating multiple image  */
  let formData = new FormData();
  if (product.pEditImages) {
    for (const file of product.pEditImages) {
      formData.append("pEditImages", file);
    }
  }
  /* Most important part for updating multiple image  */
  formData.append("pId", product.pId);
  formData.append("pName", product.pName);
  formData.append("pDescription", product.pDescription);
  formData.append("pStatus", product.pStatus);
  
  // Handle pCategory array properly
  if (Array.isArray(product.pCategory)) {
    product.pCategory.forEach(cat => {
      // Extract ID if it's an object, otherwise use the ID directly
      const catId = typeof cat === 'object' ? cat._id : cat;
      formData.append("pCategory[]", catId);
    });
  }
  
  formData.append("pQuantity", product.pQuantity);
  formData.append("pPrice", product.pPrice);
  formData.append("pOffer", product.pOffer);
  formData.append("pImages", product.pImages);

  try {
    let res = await axios.post(`${apiURL}/api/product/edit-product`, formData);
    console.log("Edit product response:", res.data);
    return res.data;
  } catch (error) {
    console.error("Edit product API error:", error);
    return { error: "Erreur lors de la modification du produit" };
  }
};

export const deleteProduct = async (pId) => {
  try {
    let res = await axios.post(`${apiURL}/api/product/delete-product`, { pId });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const productByCategory = async (catId) => {
  try {
    let res = await axios.post(`${apiURL}/api/product/product-by-category`, {
      catId,
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

// export const productByPrice = async (price) => {
//   try {
//     let res = await axios.post(`${apiURL}/api/product/product-by-price`, {
//       price,
//     });
//     return res.data;
//   } catch (error) {
//     console.log(error);
//   }
// };
